import { useQuery } from "@tanstack/react-query";
import { getTaskListAreas } from "../repositories/TaskListAreasRepository";

export const TASK_LIST_AREAS_QUERY_KEYS = {
	all: ["taskListAreas"] as const,
	byAsset: (assetId: number | null) => ["taskListAreas", assetId] as const,
};

export const useTaskListAreas = (assetId: number | null, enabled = true) => {
	return useQuery({
		queryKey: TASK_LIST_AREAS_QUERY_KEYS.byAsset(assetId),
		queryFn: ({ signal }) => getTaskListAreas(assetId, signal),
		enabled,
		keepPreviousData: true,
	});
};
